
import cookies from "../components/client/cookies";
import HttpClient from "../components/client/httpclient";
import 'regenerator-runtime/runtime';

let sd = null;
const method = 'GET';

export const Webtracking = {
    /* Added to allow logging after call tracking finishes.
    This code is fired from server side a script block tied to the _ictt variable setup. */

    init: (params) => {
        sd = params;
    },
    sendToGTM: (options) => {
        var eventName = '';
        var eventElement = null;
        if (options.eventName) eventName = options.eventName;
        if (options.eventElement) eventElement = options.eventElement;
        if (window.dataLayer) {
            window.dataLayer.push({
                event: eventName,
                enterElement: eventElement
            });
        }
    },

    // Push data to data layer
    pushToDatalayer: (eventName, eventCategory, eventCategoryName) => {
        var key = eventCategory;
        var obj = {};
        if (window.dataLayer) {
            key = eventCategory;
            obj.event = eventName;
            if (eventCategory !== '') {
                obj[key] = eventCategoryName;
            }
            window.dataLayer.push(obj);
        }
    },

    stringToGUID: (str) => {
        return str.replace(
            /([a-f\d]{8})([a-f\d]{4})([a-f\d]{4})([a-f\d]{4})([a-f\d]{12})/,
            '$1-$2-$3-$4-$5'
        );
    },

    // Create tracking cookies
    track: () => {
        var tpValue = '';
        var visitorId = "";

        let s = document.querySelectorAll(".DelaconNumber span");

        tpValue = s.length > 0 ? s[0].innerHTML : 0;

        tpValue = tpValue.replace(/ /g, '').replace('+', '');

        Webtracking.setReferrerCookies();

        Webtracking.getUTM();

        //new delacon implementation
        //check for existing vid from old infinity script
        //todo remove after ids have been solved as this might become deprecated over time since we no longer use infinity
        var infinityVidJson = localStorage.getItem("_its.2271");

        //parse the JSON string into an object
        var infinityVid = JSON.parse(infinityVidJson || '{}');

        //check if there was an existing vid to pull from pre-delacon
        if (infinityVid.vid && infinityVid.vid.value) {
            visitorId = infinityVid.vid.value;
        } else {
            visitorId = localStorage.getItem("VisitorId");
        }

        if (visitorId == null) {
            var sessionId = Webtracking.stringToGUID(cookies.read("delaconsessid"));
            localStorage.setItem("VisitorId", sessionId);
            visitorId = sessionId;
        }

        //ictf_master cookie was created by old Infinity script but in new script this is not available.
        //we are creating this cookie manually for a session with appropriate value based on new Infinity script.
        if (!cookies.read('ictf_master')) {
            cookies.create('ictf_master', visitorId);
        }

        if (sd.globals.firstVisit) {
            let ictvid = visitorId || '';
            let bv_id = localStorage.getItem('bv_session_id');
            let trackingUrl = process.env.NODE_ENV === "development" ? '/src/api/webtracking.json?' : '/webtracking.axd?';
            const URL = trackingUrl + '&TP=' + tpValue + '&WP=' + encodeURIComponent(document.location) +
                '&SS=' + window.screen.width + 'x' + window.screen.height + '&AV=' + escape(navigator.appVersion) +
                '&PG=' + UV.page.productGroup + '&VID=' + ictvid + '&bvid=' + bv_id;
            HttpClient.AsyncGetRequest(URL, method);
        }
    },

    //sets and updates the first and last referrer/query cookies using the documents referrer
    setReferrerCookies: () => {
        const DEFAULT_UTM = { medium: "direct", source: "direct", campaign: "direct" };
        const ORGANIC_UTM = { medium: "organic-search", campaign: "organic-search" };

        // Get document referrer and UTM parameters
        const referrer = document.referrer ? encodeURIComponent(document.referrer) : "";
        const utmMedium = Webtracking.getQueryParameterByName('utm_medium') || "";
        const utmSource = Webtracking.getQueryParameterByName('utm_source') || "";
        const utmCampaign = Webtracking.getQueryParameterByName('utm_campaign') || "";

        // Determine UTM values
        const isReferrerGoogle = referrer.includes(".google.com");
        const utmValues = {
            medium: utmMedium || (referrer ? ORGANIC_UTM.medium : DEFAULT_UTM.medium),
            source: utmSource || (isReferrerGoogle ? "google" : DEFAULT_UTM.source),
            campaign: utmCampaign || (referrer ? ORGANIC_UTM.campaign : DEFAULT_UTM.campaign),
        };

        // Handle first visit cookies
        if (!cookies.read('LTG_Referrer')) {
            const days = 180; // Cookie expiry in days
            Webtracking.createUTMCookies(referrer || utmValues.medium, utmValues, days);
            sd.globals.firstVisit = true;
        } else {
            Webtracking.updateCurrentCookies(referrer, utmValues);
        }
    },

    createUTMCookies: (referrer, utmValues, days) => {
        if (!referrer.includes('.scottdunn.com')) {
            const queryString = Webtracking.updateUTMParams("", utmValues.source, utmValues.medium, utmValues.campaign);
            cookies.create('LTG_Referrer', referrer, days);
            cookies.create('LTG_Current_Referrer', referrer);
            cookies.create('LTG_Query', queryString, days);
            cookies.create('LTG_Current_Query', queryString);
        }
    },

    updateCurrentCookies: (referrer, utmValues) => {
        if (!referrer.includes('.scottdunn.com')) {
            cookies.update('LTG_Current_Referrer', referrer || utmValues.medium);

            const queryString = Webtracking.determineUpdatedQueryString(referrer, utmValues);
            cookies.update('LTG_Current_Query', queryString);
        }
    },

    determineUpdatedQueryString: (referrer, utmValues) => {
        if (!referrer && !document.location.search) {
            return Webtracking.updateUTMParams("", utmValues.source, "direct", utmValues.campaign);
        }
        if (referrer.includes(".google.com") && !document.location.search) {
            return Webtracking.updateUTMParams("", "google", "organic-search", "organic-search");
        }
        return document.location.search || Webtracking.updateUTMParams("", utmValues.source, utmValues.medium, utmValues.campaign);
    },

    updateUTMParams: (queryString, utmSource, utmMedium, utmCampaign) => {
        const urlParams = new URLSearchParams(queryString);
        urlParams.set('utm_source', utmSource);
        urlParams.set('utm_medium', utmMedium);
        urlParams.set('utm_campaign', utmCampaign);
        return `?${urlParams.toString()}`;
    },

    getQueryParameterByName: (name) => {
        const url = window.location.search;
        const params = new URLSearchParams(url);
        return params.get(name);
    },

    getUTM: () => {
        /*
          Example URL:
          https://www.scottdunn.com/travel-lounge?utm_source=google&utm_medium=cpc&utm_content=Travel-Lounge-in-Fulham-Sitelink&utm_campaign=UK-Brand_Sitelink&utm_term=scott%20dunn%20caribbean&kclickid=_k_Cj0KCQiA8_PfBRC3ARIsAOzJ2uqrMiyAAIDwCKAFtJsOTkNY_5gYWUaaYGKT5V7IDcUOmTqwcN2Pd1saAhFfEALw_wcB_k_&utm_content=Scott%20Dunn%20-%20Caribbean%20-%20Exact&utm_campaign=UK%20-%20Scott%20Dunn%20-%20Caribbean&k_clickid=_k_Cj0KCQiA8_PfBRC3ARIsAOzJ2uqrMiyAAIDwCKAFtJsOTkNY_5gYWUaaYGKT5V7IDcUOmTqwcN2Pd1saAhFfEALw_wcB_k_&infinity=ict2~net~gaw~ar~184982315431~kw~scott%20dunn%20caribbean~mt~e~cmp~UK%20-%20Scott%20Dunn%20-%20Caribbean~ag~Scott%20Dunn%20-%20Caribbean%20-%20Exact&gclid=Cj0KCQiA8_PfBRC3ARIsAOzJ2uqrMiyAAIDwCKAFtJsOTkNY_5gYWUaaYGKT5V7IDcUOmTqwcN2Pd1saAhFfEALw_wcB
        */
        var utmTerm;
        var utmTerms = Webtracking.getSavedTerms();
        var i;
        var term;
        var utcDate = new Date().getUTCDate();
        if (document.location.search.indexOf('utm_term') > 1) {
            utmTerm = Webtracking.getQueryParameterByName('utm_term');
            // check local storage and remove older terms
            if (utmTerms && utmTerms.length) {
                for (i = 0; i < utmTerms.length; i += 1) {
                    term = utmTerms[i].term;
                    if ((term === utmTerm) &&
                        ((Date.parse(utmTerms[i].date) < Date.parse(new Date().toUTCString())) ||
                            (i > 10))) {
                        utmTerms.splice(i, 1);
                    }
                }
            }
            // update recents
            utmTerms.push({
                term: utmTerm,
                date: new Date(new Date().setUTCDate(utcDate + 90)).toUTCString()
            });
            localStorage.setItem('utmTerm', JSON.stringify(utmTerms));
        }
    },

    isValidJSON: (jsonStr) => {
        try {
            JSON.parse(jsonStr);
            return true;
        } catch (error) {
            return false;
        }
    },

    isExpectedObject: (obj) => {
        if (obj.term && obj.date) return true;
        return false;
    },

    getSavedTerms: () => {
        var termsCollection = [];
        var termsJson = localStorage.getItem('utmTerm');
        var parsedTerms = [];
        if (termsJson && Webtracking.isValidJSON(termsJson)) {
            parsedTerms = JSON.parse(termsJson);
            // Check that the data is not old or corrupted
            if (parsedTerms.length && Webtracking.isExpectedObject(parsedTerms[0])) {
                termsCollection = parsedTerms;
            }
        }
        return termsCollection;
    },

    getSavedTermsString: () => {
        var termsString = '';
        var termCollection = Webtracking.getSavedTerms();
        var terms = [];
        var i;
        // Construct the array as FIFO
        for (i = termCollection.length - 1; i > -1; i -= 1) {
            terms.push(termCollection[i].term);
        }
        if (terms.length) termsString = terms.join(',');
        return termsString;
    },

    getQueryParameterByName: (name, url) => {
        var regex;
        var results;
        var sanitisedName = name.replace(/[[\]]/g, '\\$&');
        var urlToUse = url;
        if (!urlToUse) urlToUse = window.location.href;
        regex = new RegExp(sanitisedName + '(=([^&#]*)|&|#|$)');
        results = regex.exec(urlToUse);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2]);
    }
};

export const LTGTracking = {
    init: () => {
        Webtracking.track();
    }
}

export const GATracking = {
    eventTracking: (event, eventCategory, eventAction, eventLabel) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': event,
            'event_category': eventCategory,
            'event_action': eventAction,
            'event_label': eventLabel,
        });
    },
    formValidation: (event, formName, formStatus) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": event,
            "form_name": formName,
            "form_status": formStatus,
        });
    },
    // specifc to custom object requirements that need more flexible information/fields
    customObjectEventTracking: (event, eventCategory, eventAction, customEventObject) => {
        window.dataLayer = window.dataLayer || [];

        let eventObject = {
            'event': event,
            'event_category': eventCategory,
            'event_action': eventAction
        };

        Object.assign(eventObject, customEventObject);

        window.dataLayer.push(eventObject);
    }
}

export default Webtracking;